module.exports = __webpack_public_path__ + "media/images/icon-order-disabled-adab64f69b69da43b12c89f118098796.svg";